import type { KeyboardEvent } from 'react'

export const isEnter = (e: KeyboardEvent) =>
  e.code === 'Enter' || e.code === 'NumpadEnter'

export const isEnterPrevented = (e: KeyboardEvent<HTMLElement>) =>
  !!(e.target as HTMLElement).attributes.getNamedItem(
    'data-prevent-enter-submit',
  )
